import React, {useState, useEffect, useCallback} from "react";
import {Row, Col, FormGroup, Input, ModalFooter} from "reactstrap";
import Button from "../Button/Button";
import PropTypes from "prop-types";
import {
  sendAddsimModalData,
  sendEditSimModalData,
  updateAddsimModal,
  updateAddsimModalData,
} from "../../redux/Actions/sims.actions";
import {useDispatch, useSelector} from "react-redux";
import {getSimModalData} from "../../redux/Selectors/sim.selector";
import {isEmpty} from "lodash";
import {toast} from "react-toastify";
import {useFetchSims} from "../../views/SIMs/simsTable/useSimTableData";

const SimForm = ({onClose}) => {
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useDispatch();
  const {refetch} = useFetchSims();
  const update_sim_data = useSelector(getSimModalData);
  const {carrier = "", iccid = "", imei = ""} = update_sim_data;
  const onFormSubmit = () => {
    setSubmitted(true);
    if (!isEmpty(iccid) && !isEmpty(imei) && !isEmpty(carrier)) {
      const callback = () => {
        onClose();
        refetch();
      };
      if (update_sim_data.id) {
        dispatch(sendEditSimModalData(update_sim_data, callback));
      } else {
        dispatch(sendAddsimModalData(update_sim_data, callback));
      }
    } else {
      toast.error("Please check required fields");
    }
  };
  const onFormCancel = useCallback(() => {
    dispatch(updateAddsimModal(false));
    dispatch(updateAddsimModalData({}));
    onClose();
  }, [dispatch, onClose]);
  useEffect(() => {
    window.addEventListener("beforeunload", onFormCancel);
    return () => {
      window.removeEventListener("beforeunload", onFormCancel);
    };
  }, [onFormCancel]);

  const onChangeHandler = (e) => {
    let updateObj = {...update_sim_data};
    updateObj = Object.assign({}, updateObj, {[e.target.name]: e.target.value});
    dispatch(updateAddsimModalData(updateObj));
  };
  return (
    <>
      <div>
        <div className="pl-lg-4">
          <Row>
            <Col lg="12">
              Carrier <span className="text-red">*</span>
              <FormGroup check>
                <label className="form-control-label" htmlFor="activated-yes">
                  <Input
                    className="form-control-alternative"
                    // defaultValue="United States"
                    id="activated-yes"
                    type="radio"
                    value="VERIZON"
                    data-cy={"VERIZON"}
                    invalid={submitted && isEmpty(carrier)}
                    name="carrier"
                    onChange={onChangeHandler}
                    checked={carrier === "VERIZON"}
                  />
                  Verizon
                </label>
              </FormGroup>
              <FormGroup check>
                <label className="form-control-label" htmlFor="activated-no">
                  <Input
                    className="form-control-alternative"
                    // defaultValue="United States"
                    id="activated-no"
                    type="radio"
                    value="ATT"
                    data-cy={"ATT"}
                    invalid={submitted && isEmpty(carrier)}
                    name="carrier"
                    onChange={onChangeHandler}
                    checked={carrier === "ATT"}
                  />
                  ATT
                </label>
              </FormGroup>
            </Col>
            <Col lg="12">
              <FormGroup>
                <label className="form-control-label" htmlFor="iccid">
                  ICCID <span className="text-red">*</span>
                </label>
                <Input
                  className="form-control-alternative"
                  // defaultValue="United States"
                  id="iccid"
                  placeholder="ICCID"
                  type="text"
                  value={iccid}
                  invalid={submitted && isEmpty(iccid)}
                  data-cy={"iccid"}
                  name="iccid"
                  onChange={onChangeHandler}
                />
              </FormGroup>
            </Col>
            <Col lg="12">
              <FormGroup>
                <label className="form-control-label" htmlFor="imei">
                  IMEI <span className="text-red">*</span>
                </label>
                <Input
                  className="form-control-alternative"
                  // defaultValue="United States"
                  id="imei"
                  placeholder="IMEI"
                  type="text"
                  value={imei}
                  invalid={submitted && isEmpty(imei)}
                  name="imei"
                  data-cy={"imei"}
                  onChange={onChangeHandler}
                />
              </FormGroup>
            </Col>
          </Row>
        </div>
      </div>
      <ModalFooter>
        <Button onClick={onFormSubmit} data-cy={"submit-btn"}>
          SUBMIT
        </Button>
        <Button onClick={onFormCancel} type={"info-small"} data-cy={"cancel-btn"}>
          CANCEL
        </Button>
      </ModalFooter>
    </>
  );
};

SimForm.propTypes = {
  onFormSubmit: PropTypes.func.isRequired,
};

export default SimForm;
